// extracted by mini-css-extract-plugin
export default {"wrapper":"Status_wrapper__xnMi0","darkMode":"Status_darkMode__JjUlb","value":"Status_value__uPUhP","label":"Status_label__7Zwa3","percent":"Status_percent__2Y5Ab"};